import { request } from '../methods'

export default {
  getRates: request('get', '/api/v1/raters/'),
  createRate: request('post', '/api/v1/raters/upload/'),
}
